<template>
    <div>
        <Breadcrumb section-name="Report" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="row mb-3 g-2 align-items-end">
                        <div class="col-auto">
                            <a class="btn btn-option" href="javascript:void(0)" @click="downloadFile">
                                <img v-if="!exportLoading" class="print" width="16" height="16"/>
                                <span v-if="exportLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </a>
                        </div>
                        <div class="col-md-3 form-group mb-0">
                            <select class="form-control" v-model="params.project_id" name="project_id">
                                <option value="">Select Project</option>
                                <option v-for="each in projects" :key="each.id" :value="each.id" v-text="each.name"></option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-inverse-primary w-100" @click="fetchSlotReport">Search</button>
                        </div>
                    </div>
                    <div class="table-height long-scroll">
                        <table class="table mb-0 table-striped table-bordered dataTable">
                            <thead>
                            <tr>
                                <th>SI</th>
                                <th>Project Name</th>
                                <th>Slot Name</th>
                                <th>From Date</th>
                                <th>To Date</th>
                                <th class="text-end">Slot Amount</th>
                                <th>Remarks</th>
                            </tr>
                            </thead>
                            <template v-if="!loading && reportData['data']?.length > 0">
                                <tbody>
                                <tr v-for="(data,index) in reportData['data']" :key="data.id || index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ data.project_name }}</td>
                                    <td>{{ data.slot_name }}</td>
                                    <td>{{ data.from_date }}</td>
                                    <td>{{ data.to_date }}</td>
                                    <td class="text-end">{{ data.amount }}</td>
                                    <td>{{ data.remarks }}</td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <th class="text-end" colspan="5">Total</th>
                                    <th class="text-end">{{ reportData.total.amount }}</th>
                                    <th></th>
                                </tr>
                                </tfoot>
                            </template>
                            <template v-if="!loading && (!reportData['data'] || reportData['data'].length === 0)">
                                <tr class="text-center">
                                    <td colspan="100" class="fw-bold fs-6 text-height">
                                        No Data Found
                                        <br>
                                        Please search by project.
                                    </td>
                                </tr>
                            </template>
                            <tbody v-if="loading">
                            <tr>
                                <td colspan="100" class="loader-height">
                                    <Loader></Loader>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import Breadcrumb from "../Common/Breadcrumb.vue";
import Loader from "../Common/Loader.vue";

export default {
    components: {Loader, Breadcrumb},
    data() {
        return {
            breadCrumb: ['Slot Report'],
            reportData: {},
            projects: [],
            params: {
                project_id: ''
            },
            loading: false,
            exportLoading: false,
        }
    },
    methods: {
        downloadFile: function () {
            if (!this.params.project_id) {
                return;
            }
            PrintService.print('/report/slot/print?project_id=' + this.params.project_id);
        },
        fetchProject() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data;
                }
            });
        },
        fetchSlotReport() {
            this.loading = true;
            ApiService.POST(ApiRoutes.Report + '/slot', this.params, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.reportData = res;
                }
            });
        }
    },
    created() {
        this.fetchProject();
    }
}
</script>
